import React, { useState, useEffect, useRef } from 'react';
import { Card, Image, message, Spin, Form, Button, Row, Col, Modal, Popconfirm, Select, Input, DatePicker, InputNumber, TimePicker, Cascader, Tabs, Descriptions, Rate, Upload, Pagination, Alert, Radio } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { SearchOutlined, EditOutlined, FileTextOutlined, DeleteOutlined, PlusOutlined, CalendarOutlined, PlusCircleOutlined, BarChartOutlined, PictureOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ResizableTable from '../components/ResizableTable';
import BMIScale from '../components/BMIScale';
import PostClassFeedback from '../components/PostClassFeedback';
import CustomerSelector from '../components/CustomerSelector';


const { Option } = Select;

// Filter components
const NameFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8 }}>
    <Input
      placeholder="搜索姓名"
      value={selectedKeys[0]}
      onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => confirm()}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
    <Button
      type="primary"
      onClick={() => confirm()}
      size="small"
      style={{ width: 90, marginRight: 8 }}
    >
      搜索
    </Button>
    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
      重置
    </Button>
  </div>
);

const NameFilterIcon = filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;

const PhoneFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8 }}>
    <Input
      placeholder="搜索电话"
      value={selectedKeys[0]}
      onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => confirm()}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
    <Button
      type="primary"
      onClick={() => confirm()}
      size="small"
      style={{ width: 90, marginRight: 8 }}
    >
      搜索
    </Button>
    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
      重置
    </Button>
  </div>
);

const PhoneFilterIcon = filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;

// Remove resizable column helper and simplify fetch/initial logic
const MemberList = () => {
  // 设置 dayjs 为中文
  dayjs.locale('zh-cn');
  const [members, setMembers] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editForm] = Form.useForm();
  const [editAvatar, setEditAvatar] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchForm] = Form.useForm();
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [currentMemberDetail] = useState(null);
  const { apiClient } = useAuth();
  const [customerList, setCustomerList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [customerDisabled, setCustomerDisabled] = useState(false);
  const [initialPoints, setInitialPoints] = useState(0);

  const [avatarFile, setAvatarFile] = useState(null); // 存储头像文件
  // 生长发育百分位图相关状态
  const [percentileModalVisible, setPercentileModalVisible] = useState(false);
  const [percentileLoading, setPercentileLoading] = useState(false);
  const [percentileError, setPercentileError] = useState(null);
  const [percentileImageSrc, setPercentileImageSrc] = useState(null);
  const [percentileTargetMember, setPercentileTargetMember] = useState(null);

    // 阶段测评相关状态
    const [evaluationModalVisible, setEvaluationModalVisible] = useState(false);
    const [currentEvaluationMember, setCurrentEvaluationMember] = useState(null);
    const [evaluationList, setEvaluationList] = useState([]);
    const [evaluationForm] = Form.useForm();
    const [evaluationLoading, setEvaluationLoading] = useState(false);
    const [evaluationImages, setEvaluationImages] = useState([]);
    const [evaluationActiveTab, setEvaluationActiveTab] = useState('1');
    const [isEvaluationEditMode, setIsEvaluationEditMode] = useState(false);
    // 新增状态用于分页和日期筛选
    const [evaluationPagination, setEvaluationPagination] = useState({ current: 1, pageSize: 1, total: 0 });
    const [evaluationSearchParams, setEvaluationSearchParams] = useState({ searchDate: null });
    // BMI缓存
    const [bmiCache, setBmiCache] = useState(new Map());
  const [teachingModeOptions, setTeachingModeOptions] = useState([
    { label: 'SVIP专属', value: 'SVIP专属' },
    { label: 'VIP私教', value: 'VIP私教' },
    { label: '私教小团', value: '私教小团' },
    { label: '一对一', value: '一对一' },
    { label: '一对二', value: '一对二' },
    { label: '一对多', value: '一对多' }
  ]); // 私教类型选项

  // HTML解码函数
  const decodeHtml = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  // 将纯文本或旧格式统一转成安全的 HTML，用于展示模式
  const normalizeRichText = (raw) => {
    if (!raw) return '';
    let content = String(raw);
    // 先进行 HTML 解码，兼容后端存的转义内容
    try {
      content = decodeHtml(content);
    } catch (e) {
      // ignore
    }
    const trimmed = content.trim();
    if (!trimmed) return '';

    // 简单判断是否已经是 HTML 结构（包括 Quill 生成的内容）
    const htmlLikePattern = /<([a-zA-Z][^>]*)>/;
    if (
      htmlLikePattern.test(trimmed) ||
      /&nbsp;/.test(trimmed) ||
      trimmed.startsWith('<p') ||
      trimmed.startsWith('<div')
    ) {
      return trimmed;
    }

    // 纯文本：需要做转义并按换行转成 <p>/<br>
    const escaped = trimmed
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const lines = escaped.split(/\r?\n/);
    if (lines.length === 1) {
      return `<p>${lines[0] || ''}</p>`;
    }
    return lines
      .map((line) => `<p>${line || ''}</p>`)
      .join('');
  };

  // 课前/课后排课表单的初始值（用于弹框打开或切换日期无数据时重置）
  const buildInitialScheduleValues = (override = {}) => {
    const today = dayjs();
    const defaultTime = dayjs().hour(16).minute(0).second(0);
    return {
      trainDate: override.trainDate || today,
      trainTime: override.trainTime || defaultTime,
      trainTimes: 1,
      details: [
        {
          sports: [],
          sportsContent: '',
        },
      ],
      teachingMode: '一对一',
      summary: '',
      suggestion: '',
      accClasses: '',
      completion: '',
      heartRate: '',
      restTimes: '',
      points: '',
      ...override,
    };
  };

  // 排课相关 state
  const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
  const [scheduleForm] = Form.useForm();
  const [currentScheduleMember, setCurrentScheduleMember] = useState(null);
  const [sportsOptions, setSportsOptions] = useState([]);
  const [prescriptionId, setPrescriptionId] = useState(null);
  const [completeClass, setCompleteClass] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [finishConfirmVisible, setFinishConfirmVisible] = useState(false);
  // 小结/建议 查看/编辑模式（true=查看HTML，false=富文本编辑）
  const [summaryViewMode, setSummaryViewMode] = useState(true);
  const [suggestionViewMode, setSuggestionViewMode] = useState(true);

  // pagination and search params for server-side pagination
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [searchParams, setSearchParams] = useState({});

  // 添加列状态管理
  const [columns, setColumns] = useState([
    {
      title: '头像',
      dataIndex: 'photoAddress',
      key: 'photoAddress',
      width: 100,
      render: (photoAddress) => (
        <Image
          src={photoAddress}
          alt="会员头像"
          style={{ width: 70, height: 70, borderRadius: '50%' }}
          fallback="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNkZGQiLz48dGV4dCB4PSI1MCIgeT0iNTAiIGZvcnQtc2l6ZT0iMTIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiNmZmYiPk1lbWJlcjwvdGV4dD48L3N2Zz4="
        />
      ),
    },
    {
      title: '尊享会员',
      dataIndex: 'deliveryType',
      key: 'deliveryType',
      width: 120,
      render: (deliveryType) => {
        // 根据私教类型显示不同图标和文本
        let icon = null;
        let bgColor = '#f5f5f5';
        
        if (deliveryType === 'SVIP专属' || deliveryType === '一对一') {
          icon = '👑';
          bgColor = '#ffd700'; // 金色背景
        } else if (deliveryType === 'VIP私教' || deliveryType === '一对二') {
          icon = '⭐';
          bgColor = '#add8e6'; // 浅蓝色背景
        } else if (deliveryType === '私教小团' || deliveryType === '一对多') {
          icon = '👥';
          bgColor = '#98fb98'; // 浅绿色背景
        }
        
        return deliveryType ? (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: '4px 8px', 
            borderRadius: '4px', 
            backgroundColor: bgColor,
            fontSize: '12px'
          }}>
            <span style={{ marginRight: '4px' }}>{icon}</span>
            <span>{deliveryType}</span>
          </div>
        ) : (
          <span>-</span>
        );
      },
      filters: [
        { text: 'SVIP专属', value: 'SVIP专属' },
        { text: 'VIP私教', value: 'VIP私教' },
        { text: '私教小团', value: '私教小团' },
      ],
      onFilter: (value, record) => record.deliveryType === value,
    },
    {
      title: '积分',
      dataIndex: 'points',
      key: 'points',
      width: 80,
      sorter: (a, b) => {
        const pointA = parseInt(a.points) || 0;
        const pointB = parseInt(b.points) || 0;
        return pointA - pointB;
      },
      render: (points) => <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#1890ff' }}>{points || 0}</span>,
    },
    {
      title: '姓名',
      dataIndex: 'babyName',
      key: 'babyName',
      width: 100,
      sorter: (a, b) => {
        const nameA = a.babyName || '';
        const nameB = b.babyName || '';
        return nameA.localeCompare(nameB);
      },
      filterDropdown: NameFilterDropdown,
      filterIcon: NameFilterIcon,
      onFilter: (value, record) => {
        const name = record.babyName || '';
        return name.toLowerCase().includes(value.toLowerCase());
      },
      onCell: (record) => ({
        onClick: () => openPostClassFeedbackModal(record),
        style: { cursor: 'pointer' },
      }),
    },
    {
      title: '性别',
      dataIndex: 'babySex',
      key: 'babySex',
      width: 80,
      filters: [
        { text: '男', value: '1' },
        { text: '女', value: '0' },
      ],
      onFilter: (value, record) => record.babySex === value,
      render: (sex) => {
        // normalize values and map to display text
        if (sex === '0') return '女';
        if (sex === '1') return '男';
        return '未知';
      }
    },
    {
      title: '生日',
      dataIndex: 'babyBirthday',
      key: 'babyBirthday',
      width: 120,
      sorter: (a, b) => {
        const dateA = new Date(a.babyBirthday || '');
        const dateB = new Date(b.babyBirthday || '');
        return dateA - dateB;
      },
    },
    {
      title: '家长',
      dataIndex: 'parentName',
      key: 'parentName',
      width: 120,
      sorter: (a, b) => {
        const parentA = a.parentName || '';
        const parentB = b.parentName || '';
        return parentA.localeCompare(parentB);
      },
    },
    {
      title: '联系电话',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      width: 150,
      render: (text) => text ? text.split('_')[0] : '',
      filterDropdown: PhoneFilterDropdown,
      filterIcon: PhoneFilterIcon,
      onFilter: (value, record) => {
        const phone = (record.phoneNumber || '').split('_')[0];
        return phone.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: '其他号码',
      dataIndex: 'backupPhoneNumber',
      key: 'backupPhoneNumber',
      width: 150,
      render: (text) => text || '-'
    },
    {
      title: '小队',
      dataIndex: 'className',
      key: 'className',
      width: 120,
      sorter: (a, b) => {
        const classA = a.className || '';
        const classB = b.className || '';
        return classA.localeCompare(classB);
      },
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 320,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap' }}>
          <Button 
            type="primary"
            size="small" 
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)
            }
            style={{ fontSize: '12px' }}
          >
            修改
          </Button>

          <Popconfirm
            title="确认删除"
            description={`确定要删除会员"${record.babyName}"吗？`}
            onConfirm={() => handleDelete(record)}
            okText="确认"
            cancelText="取消"
          >
            <Button 
              type="primary"
              size="small" 
              icon={<DeleteOutlined />}
              danger
              style={{ fontSize: '12px' }}
            >
              删除
            </Button>
          </Popconfirm>
        </div>
      ),
    }
  ]);

    // BMI Assessment Component
    const BMIAssessment = ({ item, member, apiClient, bmiCache, setBmiCache }) => {
    const [bmiData, setBmiData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      const fetchBMI = async () => {
        const cacheKey = `${member.id}-${item.evaluationDate}-${item.height}-${item.weight}`;
        if (bmiCache.has(cacheKey)) {
          setBmiData(bmiCache.get(cacheKey));
          return;
        }
        if (!item.height || !item.weight || !member.babyBirthday || !member.babySex || !item.evaluationDate) {
          setBmiData(null);
          return;
        }
        setLoading(true);
        try {
          const params = {
            sex: parseInt(member.babySex),
            birthDate: member.babyBirthday,
            evaluationDate: item.evaluationDate,
            height: parseFloat(item.height),
            weight: parseFloat(item.weight),
          };
          const response = await apiClient.post('/sports-server-prod/taller.api.v1/hw/bmi/adolescents/data', params);
          if (response.data.code === 200) {
            setBmiData(response.data.data);
            setBmiCache(prev => new Map(prev).set(cacheKey, response.data.data));
          } else {
            setBmiData(null);
          }
        } catch (error) {
          console.error('Failed to fetch BMI data:', error);
          setBmiData(null);
        } finally {
          setLoading(false);
        }
      };
      fetchBMI();
    }, [item.height, item.weight, item.evaluationDate, member.babyBirthday, member.babySex, apiClient, bmiCache, setBmiCache]);

    if (loading) {
      return <Spin />;
    }

    if (!bmiData) {
      return <div>无法获取BMI数据</div>;
    }

    const thresholds = bmiData.bands.map(band => ({
      key: band.label,
      label: band.label,
      start: band.start,
      end: band.end,
      color: band.label === '中重度消瘦' ? '#f5222d' :
             band.label === '轻度消瘦' ? '#fa8c16' :
             band.label === '正常' ? '#52c41a' :
             band.label === '超重' ? '#faad14' :
             band.label === '肥胖' ? '#f5222d' : '#52c41a',
    }));

    return (
      <BMIScale
        value={bmiData.userBmi}
        thresholds={thresholds}
        title="BMI 体重指数（中国儿童青少年0~18岁生成标准）"
        unit="kg/m²"
        showTicks
        tickStep={1}
        style={{ marginTop: 8, width: '100%', display: 'block' }}
      />
    );
    };

  useEffect(() => {
    const init = async () => {
      // 读取缓存的校区列表
      try {
        const raw = localStorage.getItem('customerList');
        if (raw) {
          const customers = JSON.parse(raw);
          setCustomerList(customers);
        } else {
          // 获取校区列表
          await fetchCustomerList();
        }
      } catch (err) {
        console.error('读取本地校区列表失败:', err);
      }

      // 设置默认选中当前登录用户的机构
      try {
        const rawUser = localStorage.getItem('user');
        if (rawUser) {
          const user = JSON.parse(rawUser);
          if (user.customerId) {
            searchForm.setFieldsValue({ customerId: user.customerId });
            fetchClassList(user.customerId);
            handleSearch({ customerId: user.customerId });
          }
        }
      } catch (err) {
        console.error('读取用户信息失败:', err);
      }
    };

    init();
  }, []);

  // 初始化运动项目枚举
  useEffect(() => {
    if (!apiClient) return;

    const fetchSportsItems = async () => {
      try {
        const resp = await apiClient.post('/portal-server-prod/sys/enumconfig/v1/list', { tableName: 'SPORTS_ITEM' });
        if (resp.data && resp.data.code === 200 && resp.data.data) {
          let raw = resp.data.data;
          if (typeof raw === 'string') {
            try {
              raw = JSON.parse(raw);
            } catch (e) {
              console.error('解析运动项目枚举失败:', e);
              message.error('解析运动项目配置失败');
              return;
            }
          }
          const options = (raw || []).map((p) => ({
            label: p.enumName,
            value: p.enumName,
            children: (p.items || []).map((c) => ({
              label: c.enumName,
              value: c.enumName,
            })),
          }));
          setSportsOptions(options);
        } else {
          message.error(resp.data?.msg || '获取运动项目失败');
        }
      } catch (e) {
        console.error('获取运动项目失败:', e);
        message.error('获取运动项目失败');
      }
    };

    fetchSportsItems();
  }, [apiClient]);

  // 获取私教类型枚举
  useEffect(() => {
    if (!apiClient) return;

    const fetchTeachingModes = async () => {
      try {
        const resp = await apiClient.post('/portal-server-prod/sys/enumconfig/v1/list', { 
          tableName: 'TEACH_MODE',
          colName: 'TEACH_MODE'
        });
        if (resp.data && resp.data.code === 200 && resp.data.data) {
          let raw = resp.data.data;
          if (typeof raw === 'string') {
            try {
              raw = JSON.parse(raw);
            } catch (e) {
              console.error('解析私教类型枚举失败:', e);
              message.error('解析私教类型配置失败');
              return;
            }
          }
          const options = (raw || []).map((item) => ({
            label: item.enumName,
            value: item.enumName,
          }));
          setTeachingModeOptions(options);
        } else {
          message.error(resp.data?.msg || '获取私教类型失败');
        }
      } catch (e) {
        console.error('获取私教类型失败:', e);
        message.error('获取私教类型失败');
      }
    };

    fetchTeachingModes();
  }, [apiClient]);

  // Handle class list and role-based settings
  useEffect(() => {
    // 角色检查
    try {
      const rawUser = localStorage.getItem('user');
      if (rawUser) {
        const user = JSON.parse(rawUser);
        if (user.role !== 'R00001') {
          setCustomerDisabled(true);
          // 设置校区为用户自己的 customerId
          searchForm.setFieldsValue({
            customerId: user.customerId || customerList[0]?.customerId
          });
          // 如果有 customerId，获取班级列表
          const cid = user.customerId || customerList[0]?.customerId;
          if (cid) {
            fetchClassList(cid);
          }
        } else {
          setCustomerDisabled(false);
        }
      }
    } catch (err) {
      console.error('读取用户信息失败:', err);
    }

    // 页面卸载时清除班级列表缓存 - 这里可以选择不清除，因为现在按customerId缓存
  }, [customerList, searchForm]);

  // helper: build initial form values merging backend detail and table record
  const buildInitialMember = (detail, record) => {
    const initial = {};
    initial.id = record.id;
    // 使用会员自己的userId，而不是从localStorage获取
    // 使用会员自己的的userId，而不是从localStorage获取
    initial.userId = record.userId;
    initial.babyName = detail.userName || record.babyName || '';
    initial.babySex = (detail.sex || detail.userSex || record.babySex) ?? record.babySex;
    initial.babyBirthday = detail.babyBirthday || record.babyBirthday || null;
    initial.parentName = detail.parentName || record.parentName || '';
    initial.phoneNumber = (detail.phoneNumber || record.phoneNumber || '').split('_')[0];
    initial.backupPhoneNumber = detail.backupPhoneNumber || record.backupPhoneNumber || '';
    initial.photoAddress = detail.photoAddress || record.photoAddress || '';
    initial.classId = detail.classId || record.classId || '';
    initial.className = detail.className || record.className || '';
    // preserve customerId if present in detail/record, otherwise default to first cached customer
    initial.customerId = detail.customerId || record.customerId || (customerList && customerList[0] && customerList[0].customerId) || '';
    // 私教类型
    initial.deliveryType = detail.deliveryType || record.deliveryType || '';
    // 过期日期
    initial.expireDate = detail.expireDate || record.expireDate || null;
    // avoid nested ternary
    if (detail.points != null) initial.points = detail.points;
    else if (record.points != null) initial.points = record.points;
    else initial.points = 0;
    return initial;
  };

  // ensure a value is converted to a dayjs object (or null)
  const toMoment = (val) => {
    if (!val) return null;
    // if already has isValid, assume it's a compatible date object (dayjs/moment)
    if (typeof val === 'object' && typeof val.isValid === 'function') return val;
    const d = dayjs(val);
    return d && typeof d.isValid === 'function' && d.isValid() ? d : null;
  };

  const computeTotal = (data, pageSize, list) => {
    if (!data) return list.length;
    if (data.total != null) return Number(data.total);
    if (data.totalPage) return Number(data.totalPage) * Number(pageSize);
    return list.length;
  };

  // Fetch class list based on customerId
  const fetchClassList = async (customerId) => {
    if (!customerId) {
      setClassList([]);
      return;
    }
    // 先尝试从缓存读取
    try {
      const cached = localStorage.getItem(`classList_${customerId}`);
      if (cached) {
        const parsed = JSON.parse(cached);
        // 确保解析后的结果是数组
        if (Array.isArray(parsed)) {
          setClassList(parsed);
          return;
        }
      }
    } catch (err) {
      console.error('读取班级缓存失败:', err);
    }
    // 缓存没有，调用API
    try {
      const response = await apiClient.post(`/sports-server-prod/api.v1/customer/queryClassList?customerId=${customerId}`);
      if (response.data.code === 200) {
        const list = response.data.data.list || [];
        setClassList(list);
        localStorage.setItem(`classList_${customerId}`, JSON.stringify(list));
      } else {
        message.error('获取班级列表失败');
        setClassList([]);
      }
    } catch (error) {
      console.error('获取班级列表错误:', error);
      message.error('获取班级列表失败');
      setClassList([]);
    }
  };

  // Fetch members from server with pagination and optional search filters
  const fetchMembers = async ({ pageNum = 1, pageSize = 10, customerId, classId, name, parent, phone, backupPhone } = {}) => {
    if (!apiClient) {
      console.error('API客户端未初始化');
      message.error('系统初始化中，请稍后重试');
      return;
    }

    setLoading(true);
    try {
      // 获取最新的表单值，确保使用用户最新选择的校区
      const formValues = searchForm.getFieldsValue();
      const params = {
        pageNum,
        pageSize,
        classId: classId || '',
        customerId: customerId || formValues.customerId || searchParams.customerId || JSON.parse(localStorage.getItem('user') || '{}').customerId,
        ...(name ? { name } : {}),
        ...(parent ? { parent } : {}),
        ...(phone ? { phone } : {}),
        ...(backupPhone ? { backupPhone } : {}),
      };

      const response = await apiClient.get('/sports-base-server-prod/main/getBabyList', { params });

      if (response.data && response.data.result === '1') {
        const list = response.data.babyList || [];
        const total = computeTotal(response.data, pageSize, list);
        setMembers(list);
        setPagination(prev => ({ ...prev, current: pageNum, pageSize, total }));
        setTotalRecord(total); // <-- update totalRecord state
      } else {
        message.error(response.data?.msg || '获取会员列表失败');
      }
    } catch (error) {
      console.error('获取会员列表错误:', error);
      message.error('获取会员列表失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // When search form is submitted, save search params and fetch first page with those params
  const handleSearch = (values) => {
    // 获取表单最新值，确保包含用户选择的校区
    const formValues = searchForm.getFieldsValue();
    const searchValues = { ...formValues, ...values };
    setSearchParams(searchValues || {});
    // fetch first page with provided search params
    fetchMembers({ pageNum: 1, pageSize: pagination.pageSize, ...searchValues });
  };

  const handleReset = () => {
    searchForm.resetFields();
    setSearchParams({});
    // reset to first page and refetch
    fetchMembers({ pageNum: 1, pageSize: pagination.pageSize });
  };


  // 编辑功能：拉取详情并打开编辑表单（头像不可编辑）
  const handleEdit = async (record) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/sports-server-prod/taller.api.v1/points/queryById?userId=${record.id}`);

      const detail = (response.data && response.data.code === 200 && response.data.data) ? response.data.data : {};

      const initial = buildInitialMember(detail, record);

      // build backup phones array
      let backupList = [];
      if (initial.backupPhoneNumber && typeof initial.backupPhoneNumber === 'string') {
        backupList = initial.backupPhoneNumber.split(',').filter(Boolean);
      } else if (Array.isArray(initial.backupPhoneNumber)) {
        backupList = initial.backupPhoneNumber;
      }

      editForm.setFieldsValue({
        id: initial.id,
        userId: initial.userId,
        babyName: initial.babyName,
        babySex: initial.babySex,
        babyBirthday: toMoment(initial.babyBirthday),
        parentName: initial.parentName,
        phoneNumber: initial.phoneNumber,
        backupPhones: backupList,
        photoAddress: initial.photoAddress,
        customerId: initial.customerId,
        classId: initial.classId,
        className: initial.className,
        points: initial.points,
        deliveryType: initial.deliveryType, // 私教类型
        expireDate: toMoment(initial.expireDate), // 过期日期
      });

      setEditModalVisible(true);
      setIsCreating(false);
      setEditAvatar(initial.photoAddress || '');
      setAvatarFile(null); // 清空头像文件
      setInitialPoints(initial.points); // initialize points
    } catch (error) {
      console.error('获取编辑详情错误:', error);
      message.error('获取编辑信息失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 新增会员：打开编辑表单（创建模式）
  const handleAdd = () => {
    // reset form to empty defaults for creation
    editForm.resetFields();
    editForm.setFieldsValue({
      babySex: '1',
      points: 0,
      customerId: searchParams.customerId || (customerList && customerList[0] && customerList[0].customerId) || undefined,
      classId: classList[0] && classList[0].classId || undefined,
    });
    setEditAvatar('');
    setAvatarFile(null); // 清空头像文件
    setIsCreating(true);
    setEditModalVisible(true);
  };

  // 积分失去焦点时更新积分
  const handlePointsBlur = async () => {
    const currentPoints = editForm.getFieldValue('points');
    const diff = currentPoints - initialPoints;
    if (diff !== 0) {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const payload = {
          userId: editForm.getFieldValue('id'),
          userName: editForm.getFieldValue('babyName'),
          points: diff,
          createUser: user.name,
          remark: "积分调整"
        };
        await apiClient.post('/sports-server-prod/taller.api.v1/points/upd', payload);
        message.success('积分更新成功');
        setInitialPoints(currentPoints);
      } catch (err) {
        message.error('积分更新失败');
      }
    }
  };

  // 保存编辑后的信息
  const handleSaveEdit = async () => {
    try {
      const values = await editForm.validateFields();

      // 处理手机号码，去掉_及之后的部分
      values.phoneNumber = values.phoneNumber.split('_')[0];

      let storedUserId;
      try {
        const rawUser = localStorage.getItem('user');
        if (rawUser) {
          const parsed = JSON.parse(rawUser);
          storedUserId = parsed?.userId;
        }
      } catch (storageErr) {
        console.error('解析本地用户信息失败:', storageErr);
      }
      
      // 当创建新会员时，使用当前登录用户的userId作为关联
      // 当编辑现有会员时，保留会员自己的userId
      const resolvedUserId = isCreating ? storedUserId : (values.userId || storedUserId);
      if (!resolvedUserId) {
        message.error('未获取到用户ID，请重新登录后重试');
        return;
      }

      let formattedBirthday;
      if (values.babyBirthday) {
        // values.babyBirthday may be a dayjs object or string
        if (typeof values.babyBirthday.format === 'function') formattedBirthday = values.babyBirthday.format('YYYY-MM-DD');
        else formattedBirthday = values.babyBirthday;
      }

      // 处理过期日期
      let formattedExpireDate;
      if (values.expireDate) {
        if (typeof values.expireDate.format === 'function') formattedExpireDate = values.expireDate.format('YYYY-MM-DD');
        else formattedExpireDate = values.expireDate;
      }

      const payload = {
        // only include id when editing existing member
        ...(values.id ? { id: values.id } : {}),
        userId: resolvedUserId,
        babyName: values.babyName,
        babySex: values.babySex,
        babyBirthday: formattedBirthday,
        parentName: values.parentName,
        phoneNumber: values.phoneNumber,
        // join backup phones with comma
        backupPhoneNumber: (values.backupPhones || []).filter(Boolean).join(','),
        photoAddress: values.photoAddress,
        classId: values.classId,
        className: values.className,
        deliveryType: values.deliveryType || '', // 私教类型
        points: values.points != null ? values.points : 0,
        expireDate: formattedExpireDate, // 过期日期
        // include customerId for creation (or update) - prefer explicit search param or cached first customer
        customerId: values.customerId || searchParams.customerId || (customerList && customerList[0] && customerList[0].customerId) || 'S00001',
      };

      // 如果有上传的头像文件，添加fileName和uploadImage参数
      if (avatarFile) {
        // 检查头像文件大小，限制为1MB
        const maxSize = 1 * 1024 * 1024; // 1MB
        if (avatarFile.size > maxSize) {
          message.error('图片有点大，请控制在1M内');
          setLoading(false);
          return;
        }
        payload.fileName = avatarFile.name;
        // 转换为base64
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(avatarFile);
          reader.onload = () => {
            const result = reader.result.split(',')[1]; // 只取base64部分
            resolve(result);
          };
        });
        payload.uploadImage = base64;
      }

      setLoading(true);
      const resp = await apiClient.post('/sports-base-server-prod/main/updateBaby', payload);
      // success when result === '1' or code === 200
      if (resp && resp.data && (resp.data.result === '1' || resp.data.code === 200)) {
        message.success('保存成功');
        setEditModalVisible(false);
        setIsCreating(false);
        setAvatarFile(null); // 清空头像文件
        // refresh current page
        fetchMembers({ pageNum: pagination.current, pageSize: pagination.pageSize, ...searchParams });
      } else {
        message.error(resp.data?.msg || '保存失败');
      }
    } catch (err) {
      if (err.errorFields) {
        // validation error
        return;
      }
      console.error('保存编辑错误:', err);
      message.error('保存失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 删除确认
  const handleDelete = async (record) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/sports-base-server-prod/main/deleteBaby?id=${record.id}`);

      if (response.data && response.data.result === '1') {
        message.success(`删除成功: ${record.babyName}`);
        // 刷新当前页数据
        fetchMembers({ pageNum: pagination.current, pageSize: pagination.pageSize, ...searchParams });
      } else {
        message.error(response.data?.msg || '删除失败');
      }
    } catch (error) {
      console.error('删除失败:', error);
      message.error('删除失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };


  // 打开排课弹窗并查询当天是否已有排课


  // 处理日期变化，重新获取排课信息
  const handleDateChange = async (date) => {
     if (!date || !currentScheduleMember) return;

    try {
      setLoading(true);
      const resp = await apiClient.post('/sports-server-prod/taller.api.v1/prescription/pageList', {
        babyId: currentScheduleMember.id,
        searchDate: date.format('YYYY-MM-DD'),
        pageSize: 1,
        pageNo: 1,
      });

      if (resp.data && resp.data.code === 200) {
        const list = resp.data.data?.list || [];
        const total = resp.data.data?.totalRecord || 0;
        setTotalRecord(total);
        if (list.length > 0) {
          const p = list[0];
          setPrescriptionId(p.id);
          const trainDateTime = dayjs(p.trainDate || date.format('YYYY-MM-DD 16:00'));
          scheduleForm.setFieldsValue({
            trainTime: trainDateTime,
            trainTimes: p.trainTimes || 1,
            details: (p.details || []).map((d) => {
              const parts = (d.sportsItem || '').split('/').filter(Boolean);
              return {
                sports: parts,
                sportsContent: d.sportsContent || '',
              };
            }),
            teachingMode: p.teachingMode || '一对一',
            summary: normalizeRichText(p.briefSummary || ''),
            suggestion: normalizeRichText(p.suggestion || ''),
            // new feedback-related fields
            accClasses: p.accClasses != null ? p.accClasses : undefined,
            completion: p.completion != null ? p.completion : undefined,
            heartRate: p.heartRate != null ? p.heartRate : undefined,
            restTimes: p.restTimes != null ? p.restTimes : undefined,
            points: p.points != null ? p.points : undefined,
          });
          setCompleteClass(p.completeClass || '');
          setSummaryViewMode(true);
          setSuggestionViewMode(true);
        } else {
          // code=200 但列表为空：保持为“干净”的初始页面，不带上一次的值
          setPrescriptionId(null);
          setCompleteClass('');
          setTotalRecord(0);
          setSummaryViewMode(true);
          setSuggestionViewMode(true);
          const defaultTime = dayjs().hour(16).minute(0).second(0);
          scheduleForm.setFieldsValue(buildInitialScheduleValues({ trainDate: date, trainTime: defaultTime }));
        }
      } else if (resp.data) {
        message.error(resp.data.msg || '获取排课信息失败');
      }
    } catch (e) {
      console.error('获取排课信息失败:', e);
      message.error('获取排课信息失败');
    } finally {
      setLoading(false);
    }
  };

  // 保存排课
  const handleSaveSchedule = async () => {
    try {
      const values = await scheduleForm.validateFields();
      const userStr = localStorage.getItem('user') || '{}';
      const user = JSON.parse(userStr);

      if (!currentScheduleMember) {
        message.error('未找到当前会员信息');
        return;
      }

      const trainDate = values.trainDate;
      const trainTime = values.trainTime;

      const combinedDateTime = dayjs(trainDate)
        .hour(trainTime.hour())
        .minute(trainTime.minute())
        .second(0);

      const details = (values.details || [])
        .filter((d) => d && d.sports && d.sports.length > 0)
        .map((d) => ({
          sportsItem: d.sports.join('/'),
          sportsContent: d.sportsContent || '',
        }));

      if (details.length === 0) {
        message.warning('请至少添加一条课前备课记录');
        return;
      }

      const coachCustomerId = currentScheduleMember.customerId || user.customerId || '';

      const payload = {
        accClasses: values.accClasses || 0,
        babyId: currentScheduleMember.id,
        babyName: currentScheduleMember.babyName,
        briefSummary: values.summary || '',
        coach: `${currentScheduleMember.customerId}-${currentScheduleMember.classId}`,
        completion: values.completion || '',
        createUser: user.name || '',
        customerName: currentScheduleMember.customerName || '',
        details,
        heartRate: values.heartRate || '',
        id: prescriptionId || null,
        points: values.points || '',
        restTimes: values.restTimes || '',
        suggestion: values.suggestion || '',
        trainDate: combinedDateTime.format('YYYY-MM-DD HH:mm'),
        trainTimes: values.trainTimes || 1,
        updateUser: user.name || '',
        teachingMode: values.teachingMode || '一对一',
      };

      setLoading(true);
      const resp = await apiClient.post('/sports-server-prod/taller.api.v1/prescription/add', payload);
      if (resp.data && resp.data.code === 200) {
        message.success('排课保存成功');
        setScheduleModalVisible(false);
      } else {
        message.error(resp.data?.msg || '排课保存失败');
      }
    } catch (e) {
      if (e.errorFields) {
        return;
      }
      console.error('保存排课失败:', e);
      message.error('保存排课失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 结课处理
  const handleFinishClass = async () => {
    if (!prescriptionId) return;

    try {
      setLoading(true);
      const userStr = localStorage.getItem('user') || '{}';
      const user = JSON.parse(userStr);
      const values = scheduleForm.getFieldsValue();
      const classTimes = -(values.trainTimes || 1);
      const resp = await apiClient.post('/sports-server-prod/myPage/updateClassTimes', {
        customerId: currentScheduleMember.customerId,
        classId: currentScheduleMember.classId,
        id: [currentScheduleMember.id],
        classTimes: classTimes,
        userId: user.userId
      });
      if (resp && resp.data && (resp.data.result === '1' || resp.data.code === 200)) {
        // 条件满足，不提示信息，再调用真正的结课接口
        const trainDate = values.trainDate;
        const trainTime = values.trainTime;
        const combinedDateTime = dayjs(trainDate).hour(trainTime.hour()).minute(trainTime.minute()).second(0);
        const trainDateStr = combinedDateTime.format('YYYY-MM-DD HH:mm');
        const payload = {
          babyId: currentScheduleMember.id,
          babyName: currentScheduleMember.babyName,
          coach: `${currentScheduleMember.customerId}-${currentScheduleMember.classId}`,
          completeClass: "1",
          consumeClass: values.trainTimes != null ? values.trainTimes : 1,
          createUser: user.name,
          id: prescriptionId,
          points: values.points || 0,
          trainDate: trainDateStr,
          updateUser: user.name
        };
        const finishResp = await apiClient.post('/sports-server-prod/taller.api.v1/prescription/add', payload);
        if (finishResp.data && finishResp.data.code === 200) {
          message.success('结课成功');
          setCompleteClass('1');
          setFinishConfirmVisible(false);
        } else {
          message.error(finishResp.data?.msg || '结课失败');
        }
      } else {
        message.error(resp.data?.msg || '结课失败');
      }
    } catch (e) {
      console.error('结课失败:', e);
      message.error('结课失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 富文本图片上传 handler：选择文件，转 base64 插入
  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64 = e.target.result;
          const quill = quillRef.current?.getEditor();
          if (quill) {
            const range = quill.getSelection();
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'image', base64);
          }
        };
        reader.readAsDataURL(file);
      }
    };
  };

  // ReactQuill modules 配置，支持图片上传
  const quillModules = {
    toolbar: {
      container: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
      handlers: {
        image: imageHandler
      }
    }
  };

  const quillFormats = [
    'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent', 'link', 'image'
  ];

    const quillRef = useRef();
    const scheduleRef = useRef();
    const summaryRef = useRef();
    const suggestionRef = useRef();

  // 打开课后反馈弹窗
  const openPostClassFeedbackModal = async (record) => {
    // 直接调用排课模态框，PostClassFeedback组件内部会处理数据获取
    setCurrentScheduleMember(record);
    setScheduleModalVisible(true);
  };

  // 复制历史数据
  const handleCopyPreClassHistory = async () => {
    if (!currentScheduleMember) return;

    try {
      setLoading(true);
      const resp = await apiClient.get('/sports-server-prod/taller.api.v1/prescriptionDetail/getlistByBabyId', {
        params: { babyId: currentScheduleMember.id }
      });

      if (resp.data && resp.data.code === 200) {
        const list = resp.data.data?.list || [];
        const details = list.map((d) => ({
          sports: (d.sportsItem || '').split('/').filter(Boolean),
          sportsContent: d.sportsContent || '',
        }));
        scheduleForm.setFieldsValue({ details });
        message.success('复制历史成功');
      } else {
        message.error(resp.data?.msg || '获取历史数据失败');
      }
    } catch (e) {
      console.error('复制历史失败:', e);
      message.error('复制历史失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyPostClassHistory = async () => {
    if (!currentScheduleMember) return;

    try {
      setLoading(true);
      const resp = await apiClient.get('/sports-server-prod/taller.api.v1/prescription/getRecordByBabyId', {
        params: { babyId: currentScheduleMember.id }
      });

      if (resp.data && resp.data.code === 200) {
        const data = resp.data.data;
        scheduleForm.setFieldsValue({
          accClasses: data.accClasses,
          completion: data.completion,
          heartRate: data.heartRate,
          restTimes: data.restTimes,
          points: data.points,
          summary: normalizeRichText(data.briefSummary || ''),
          suggestion: normalizeRichText(data.suggestion || ''),
        });
        message.success('复制历史成功');
      } else {
        message.error(resp.data?.msg || '获取历史数据失败');
      }
    } catch (e) {
      console.error('复制历史失败:', e);
      message.error('复制历史失败');
    } finally {
      setLoading(false);
    }
  };

  // Fetch customer list
  const fetchCustomerList = async () => {
    if (!apiClient) return;
    try {
      const response = await apiClient.get('/sports-base-server-prod/myPage/searchCustomer', {
        params: { pageNum: 1, pageSize: 999 }
      });
      if (response.data.result === '1') {
        const list = response.data.customerList || [];
        setCustomerList(list);
        localStorage.setItem('customerList', JSON.stringify(list));
      }
    } catch (error) {
      console.error('获取校区列表错误:', error);
    }
  };



  // 打开阶段测评弹窗
  const openEvaluationModal = async (record, pageNum = 1, searchDate = null) => {
    setCurrentEvaluationMember(record);
    setEvaluationList([]);
    setEvaluationImages([]);
    evaluationForm.resetFields();
    evaluationForm.setFieldsValue({
      babyName: record.babyName,
      evaluationDate: dayjs(),
    });
    // 重置tab到第一个
    setEvaluationActiveTab('1');
    // 重置为新增模式
    setIsEvaluationEditMode(false);

    try {
      setEvaluationLoading(true);
      const params = {
        babyId: record.id,
        pageSize: 1,
        pageNo: pageNum,
      };
      
      // 如果有指定日期，则添加日期筛选
      if (searchDate) {
        params.searchDate = searchDate.format('YYYY-MM-DD');
      }

      const response = await apiClient.post('/sports-server-prod/taller.api.v1/evaluation/pageList', params);

      if (response.data && response.data.code === 200) {
        setEvaluationList(response.data.data?.list || []);
        setEvaluationPagination({
          current: pageNum,
          pageSize: 1,
          total: response.data.data?.totalRecord || 0
        });
        setEvaluationSearchParams({ searchDate });
      } else {
        message.error(response.data?.msg || '获取测评历史失败');
      }
    } catch (error) {
      console.error('获取测评历史失败:', error);
      message.error('获取测评历史失败');
    } finally {
      setEvaluationLoading(false);
      setEvaluationModalVisible(true);
    }
  };

  // BMI 相关辅助函数（中国标准）
  const computeBMI = (height, weight) => {
    const h = Number(height);
    const w = Number(weight);
    if (!h || !w || h <= 0 || w <= 0) return null;
    const heightM = h / 100;
    const bmi = w / (heightM * heightM);
    if (!Number.isFinite(bmi)) return null;
    return Number(bmi.toFixed(1));
  };

  // 处理测评分页变化
  const handleEvaluationPageChange = (page) => {
    openEvaluationModal(
      currentEvaluationMember, 
      page, 
      evaluationSearchParams.searchDate
    );
  };

  // 处理日期筛选（测评历史tab的日期选择）
  const handleEvaluationHistoryDateChange = (date) => {
    // 重新加载列表
    openEvaluationModal(
      currentEvaluationMember, 
      1, 
      date
    );
  };

  // 处理日期筛选（编辑tab的日期选择）
  const handleEvaluationDateChange = (date) => {
    setEvaluationSearchParams({ searchDate: date });
  };

  // 打开修改测评的标签页
  const openEditEvaluationTab = (evaluation) => {
    // 设置表单值
    evaluationForm.setFieldsValue({
      id: evaluation.id,  // 添加id字段
      babyName: currentEvaluationMember.babyName,
      evaluationDate: dayjs(evaluation.evaluationDate),
      height: evaluation.height,
      weight: evaluation.weight,
      heartRate: evaluation.heartRate,
      boneAge: evaluation.boneAge,
      briefSummary: evaluation.briefSummary,
      suggestion: evaluation.suggestion,
      trainTimes: evaluation.trainTimes,
    });
    
    // 设置图片列表
    const images = (evaluation.detailList || []).map((img, index) => ({
      uid: -index,
      name: `image-${index}.jpg`,
      status: 'done',
      url: img.phoneAddress,
      thumbUrl: img.phoneAddress,
      originFileObj: null,
    }));
    setEvaluationImages(images);
    
    // 更新日期搜索参数
    setEvaluationSearchParams({ searchDate: dayjs(evaluation.evaluationDate) });
    
    // 设置为编辑模式
    setIsEvaluationEditMode(true);
    
    // 切换到第二个tab
    setEvaluationActiveTab('2');
  };

  // 切换到新增模式
  const switchToNewEvaluationMode = () => {
    // 重置表单
    evaluationForm.resetFields();
    evaluationForm.setFieldsValue({
      babyName: currentEvaluationMember.babyName,
      evaluationDate: dayjs(),
    });
    // 清空图片
    setEvaluationImages([]);
    // 清空日期搜索参数
    setEvaluationSearchParams({ searchDate: null });
    // 设置为新增模式
    setIsEvaluationEditMode(false);
  };

  // 保存阶段测评
  const handleSaveEvaluation = async () => {
    try {
      const values = await evaluationForm.validateFields();

      if (!currentEvaluationMember) {
        message.error('未找到当前会员信息');
        return;
      }

      // 处理图片上传
      const uploadedImages = [];
      for (const file of evaluationImages) {
        if (file.originFileObj) {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj);
          await new Promise((resolve) => {
            reader.onload = async () => {
              const base64 = reader.result;
              try {
                const uploadResp = await apiClient.post('/sports-server-prod/main/uploadPicForBase64', {
                  customerId: currentEvaluationMember.customerId,
                  fileName: file.name,
                  uploadImage: base64,
                });
                if (uploadResp.data && uploadResp.data.result === "1") {
                  uploadedImages.push({ phoneAddress: uploadResp.data.url });
                } else {
                  message.error(`上传图片失败: ${file.name}`);
                }
              } catch (error) {
                message.error(`上传图片失败: ${file.name}`);
              }
              resolve();
            };
          });
        } else if (file.url) {
          // 已存在的图片
          uploadedImages.push({ phoneAddress: file.url });
        }
      }

      const userStr = localStorage.getItem('user') || '{}';
      const user = JSON.parse(userStr);

      const payload = {
        babyId: currentEvaluationMember.id,
        babyName: currentEvaluationMember.babyName,
        evaluationDate: values.evaluationDate.format('YYYY-MM-DD'),
        trainTimes: values.trainTimes || 1,
        height: values.height,
        weight: values.weight,
        heartRate: values.heartRate,
        boneAge: values.boneAge,
        briefSummary: values.briefSummary,
        suggestion: values.suggestion,
        createUser: user.name || '',
        updateUser: user.name || '',
        id: values.id || '',
        detailList: uploadedImages,
      };

      setEvaluationLoading(true);
      const resp = await apiClient.post('/sports-server-prod/taller.api.v1/evaluation/add', payload);
      if (resp.data && resp.data.code === 200) {
        message.success('测评保存成功');
        // 重置tab到第一个
        setEvaluationActiveTab('1');
        // 重置为新增模式
        setIsEvaluationEditMode(false);
        // 重新获取测评历史
        await openEvaluationModal(currentEvaluationMember, 1, null);
      } else {
        message.error(resp.data?.msg || '测评保存失败');
      }
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('保存测评失败:', error);
      message.error('保存测评失败');
    } finally {
      setEvaluationLoading(false);
    }
  };

  // 图片预览
  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    // 使用window.open直接打开图片
    window.open(src, '_blank');
  };

  // 打开生长发育百分位图弹框并请求图片
  const fetchPercentileChart = async (member) => {
    if (!apiClient) {
      message.error('系统初始化中，请稍后重试');
      return;
    }

    const babyId = member.id;
    const birthDate = member.babyBirthday;
    const sex = member.babySex;

    if (!babyId || !birthDate || (sex !== '0' && sex !== '1')) {
      setPercentileError('该学员缺少性别或生日信息，无法生成生长发育曲线');
      return;
    }

    setPercentileLoading(true);
    setPercentileError(null);
    setPercentileImageSrc(null);

    try {
      const payload = {
        sex: String(sex),
        hwType: '01',
        userInfo: {
          babyId: babyId,
          birthDate: dayjs(birthDate).format('YYYY-MM-DD'),
        },
      };

      const resp = await apiClient.post(
        '/sports-server-prod/taller.api.v1/hw/percentile/chart',
        payload,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'image/*',
          },
        }
      );

      if (!resp || !resp.data) {
        throw new Error('未获取到图片数据');
      }

      const contentType = resp.headers && (resp.headers['content-type'] || resp.headers['Content-Type']);
      const mimeType = contentType && typeof contentType === 'string' ? contentType.split(';')[0] : 'image/png';

      const blob = new Blob([resp.data], { type: mimeType || 'image/png' });
      const imageUrl = URL.createObjectURL(blob);
      setPercentileImageSrc(imageUrl);
    } catch (e) {
      console.error('获取百分位图失败:', e);
      message.error('生成生长发育曲线失败，请稍后重试');
      setPercentileError(e?.response?.data?.msg || '生成生长发育曲线失败，请稍后重试');
    } finally {
      setPercentileLoading(false);
    }
  };

  const openPercentileModal = (member) => {
    // 清理上一次的结果
    if (percentileImageSrc) {
      try {
        URL.revokeObjectURL(percentileImageSrc);
      } catch (e) {
        // ignore
      }
    }
    setPercentileTargetMember(member);
    setPercentileError(null);
    setPercentileImageSrc(null);
    setPercentileModalVisible(true);
    fetchPercentileChart(member);
  };

  const closePercentileModal = () => {
    if (percentileImageSrc) {
      try {
        URL.revokeObjectURL(percentileImageSrc);
      } catch (e) {
        // ignore
      }
    }
    setPercentileModalVisible(false);
    setPercentileTargetMember(null);
    setPercentileError(null);
    setPercentileImageSrc(null);
    setPercentileLoading(false);
  };

  return (
    <div className="menu-item-content">
      <Card title={`会员列表 (共 ${pagination.total} 条)`} style={{ margin: '16px' }}
      >
        {/* 搜索区域 */}
        <Form
          form={searchForm}
          layout="vertical"
          onFinish={handleSearch}
          style={{ marginBottom: '20px' }}
        >

          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={16}>
              <Form.Item  name="customerId">
                <CustomerSelector 
                  disabled={customerDisabled} 
                  onCustomerChange={(value) => { 
                    searchForm.setFieldsValue({ customerId: value, classId: undefined }); 
                    fetchClassList(value);
                    // 触发搜索
                    handleSearch({ customerId: value, classId: undefined });
                  }}
                  classIdValue={searchForm.getFieldValue('classId')}
                  onClassChange={(value) => {
                    searchForm.setFieldsValue({ classId: value });
                    // 触发搜索
                    handleSearch({ ...searchForm.getFieldsValue(), classId: value });
                  }}
                  classList={classList}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>新增</Button>
            </Col>
          </Row>
        </Form>
        
        <Spin spinning={loading}>
          <ResizableTable
            dataSource={members}
            columns={columns}
            onColumnsChange={setColumns}
            rowKey="id"
            scroll={{ x: 'max-content' }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
            }}
            onChange={(pag, filters, sorter) => {
              // update pagination state and fetch the new page with current search params
              setPagination(prev => ({ ...prev, current: pag.current, pageSize: pag.pageSize }));
              fetchMembers({ pageNum: pag.current, pageSize: pag.pageSize, ...searchParams });
            }}
           />
         </Spin>
      </Card>

      {/* 详情弹窗 */}
      <Modal
        title="会员详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetailModalVisible(false)}>
            关闭
          </Button>,
          <Button key="edit" type="primary" onClick={() => {
            setDetailModalVisible(false);
            // 可以在这里添加跳转到编辑页面的逻辑
          }}>
            修改
          </Button>
        ]}
      >
        {currentMemberDetail && (
          <div>
            <p><strong>ID:</strong> {currentMemberDetail.id}</p>
            <p><strong>会员ID:</strong> {currentMemberDetail.userId}</p>
            <p><strong>用户名:</strong> {currentMemberDetail.userName}</p>
            <p><strong>积分:</strong> {currentMemberDetail.points}</p>
            <p><strong>类型:</strong> {currentMemberDetail.type}</p>
            <p><strong>状态:</strong> {currentMemberDetail.state}</p>
            <p><strong>创建日期:</strong> {currentMemberDetail.createDate}</p>
            <p><strong>创建人:</strong> {currentMemberDetail.createUser}</p>
            <p><strong>备注:</strong> {currentMemberDetail.remark}</p>
          </div>
        )}
      </Modal>

      {/* 编辑弹窗 */}
      <Modal
        title="编辑会员"
        open={editModalVisible}
        onCancel={() => { setEditModalVisible(false); setIsCreating(false); }}
        footer={[
          <Button key="cancel" onClick={() => { setEditModalVisible(false); setIsCreating(false); }}>
            取消
          </Button>,
          <Button key="save" type="primary" loading={loading} onClick={handleSaveEdit}>
            保存
          </Button>
        ]}
        className="member-edit-modal"
        width={760}
      >
        {/* Avatar upload */}
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          {editAvatar || avatarFile ? (
            <div>
              <Image 
                src={avatarFile ? URL.createObjectURL(avatarFile) : editAvatar} 
                width={96} 
                height={96} 
                style={{ borderRadius: 8 }} 
              />
              <div style={{ marginTop: 8 }}>
                <Upload
                  accept="image/*"
                  showUploadList={false}
                  beforeUpload={(file) => {
                    // 验证文件类型
                    const isImage = file.type.startsWith('image/');
                    if (!isImage) {
                      message.error('只能上传图片文件！');
                      return false;
                    }
                    // 验证文件大小（小于5MB）
                    const isLt5M = file.size / 1024 / 1024 < 5;
                    if (!isLt5M) {
                      message.error('图片大小不能超过5MB！');
                      return false;
                    }
                    setAvatarFile(file);
                    setEditAvatar(''); // 清空原有头像
                    return false; // 阻止自动上传
                  }}
                >
                  <Button size="small">更换头像</Button>
                </Upload>
              </div>
            </div>
          ) : (
            <Upload
              accept="image/*"
              showUploadList={false}
              beforeUpload={(file) => {
                const isImage = file.type.startsWith('image/');
                if (!isImage) {
                  message.error('只能上传图片文件！');
                  return false;
                }
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isLt5M) {
                  message.error('图片大小不能超过5MB！');
                  return false;
                }
                setAvatarFile(file);
                return false;
              }}
            >
              <div style={{ 
                width: 96, 
                height: 96, 
                border: '1px dashed #d9d9d9', 
                borderRadius: 8, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                cursor: 'pointer',
                margin: '0 auto'
              }}>
                <div>
                  <PlusOutlined style={{ fontSize: 24, color: '#999' }} />
                  <div style={{ marginTop: 8, color: '#999' }}>上传头像</div>
                </div>
              </div>
            </Upload>
          )}
        </div>

        <Form
          form={editForm}
          layout="vertical"
          initialValues={{}}
          onFinish={handleSaveEdit}
          className="member-edit-form"
        >
          {/* Only show userId when editing existing member */}
          {!isCreating && (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item label="会员ID" name="id" rules={[{ required: true, message: '请输入会员ID' }]}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="积分" name="points" rules={[{ required: true, message: '请输入积分' }]}>
                  <InputNumber style={{ width: '100%' }} min={0} onBlur={handlePointsBlur} />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="姓名" name="babyName" rules={[{ required: true, message: '请输入姓名' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="性别" name="babySex" rules={[{ required: true, message: '请选择性别' }]}>
                <Select placeholder="请选择性别" allowClear>
                  <Option value="1">男</Option>
                  <Option value="0">女</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="生日" name="babyBirthday" rules={[{ required: true, message: '请选择生日' }]}>
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="家长" name="parentName" rules={[{ required: true, message: '请输入家长姓名' }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="联系电话" name="phoneNumber" rules={[{ required: true, message: '请输入联系电话' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="其他号码" name="backupPhones">
                <Select mode="tags" placeholder="请输入其他号码" allowClear />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={24}>
              <Form.Item noStyle dependencies={['customerId']}>
                {() => {
                  // 获取当前customerId，用于确保CustomerSelector正确渲染
                  const currentCustomerId = editForm.getFieldValue('customerId');
                  const currentClassId = editForm.getFieldValue('classId');
                  
                  return (
                    <div>
                      <Form.Item label="校区" name="customerId" rules={[{ required: true, message: '请选择校区' }]}>                
                        <CustomerSelector 
                          disabled={customerDisabled} 
                          onCustomerChange={(value) => { 
                            editForm.setFieldsValue({ classId: undefined }); 
                            fetchClassList(value); 
                          }}
                          classIdValue={currentClassId}
                          onClassChange={(value, className) => {
                            // 使用setFieldsValue更新表单值
                            editForm.setFieldsValue({ classId: value, className: className });
                          }}
                          classList={classList}
                        />
                      </Form.Item>
                      <Form.Item name="classId" hidden />
                      <Form.Item name="className" hidden />
                    </div>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
          

          
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="尊享会员" name="deliveryType">
                <Select placeholder="请选择会员类型" allowClear>
                  {teachingModeOptions.map(option => (
                    <Option key={option.value} value={option.value}>{option.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="会员过期" name="expireDate">
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD" 
                  placeholder="请选择过期日"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* 排课弹窗 */}
      <PostClassFeedback
        currentScheduleMember={currentScheduleMember}
        totalRecord={totalRecord}
        completeClass={completeClass}
        setFinishConfirmVisible={setFinishConfirmVisible}
        loading={loading}
        scheduleModalVisible={scheduleModalVisible}
        setScheduleModalVisible={setScheduleModalVisible}
        summaryViewMode={summaryViewMode}
        setSummaryViewMode={setSummaryViewMode}
        suggestionViewMode={suggestionViewMode}
        setSuggestionViewMode={setSuggestionViewMode}
        normalizeRichText={normalizeRichText}
        scheduleForm={scheduleForm}
        summaryRef={summaryRef}
        suggestionRef={suggestionRef}
        handleCopyPostClassHistory={handleCopyPostClassHistory}
        sportsOptions={sportsOptions}
        visibleTabs={['1', '2']}
        handleDateChange={handleDateChange}
        scheduleRef={scheduleRef}
        prescriptionId={prescriptionId}
      />

      {/* 阶段测评弹窗 */}
      <Modal
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>阶段测评</span>
            {evaluationActiveTab === '1' && (
              <DatePicker
                placeholder="选择日期"
                onChange={handleEvaluationHistoryDateChange}
                value={evaluationSearchParams.searchDate}
                allowClear
                style={{ marginRight: 24 }}
              />
            )}
          </div>
        }
        open={evaluationModalVisible}
        onCancel={() => setEvaluationModalVisible(false)}
        footer={null}
        width={1000}
      >
        <Tabs defaultActiveKey="1" activeKey={evaluationActiveTab} onChange={setEvaluationActiveTab}>
          <Tabs.TabPane tab="测评历史" key="1">
            <Spin spinning={evaluationLoading}>
              {evaluationList.length > 0 ? (
                evaluationList.map((item, index) => (
                  <Card 
                    key={item.id || index} 
                    style={{ marginBottom: 16 }}
                    extra={
                      <Button 
                        type="primary" 
                        size="small" 
                        onClick={() => openEditEvaluationTab(item)}
                      >
                        修改
                      </Button>
                    }
                  >
                    <Descriptions title={`测评日期: ${item.evaluationDate}`} bordered column={2}>
                      <Descriptions.Item label="身高">{item.height} cm</Descriptions.Item>
                      <Descriptions.Item label="体重">{item.weight} kg</Descriptions.Item>
                      <Descriptions.Item label="心率">{item.heartRate} 次/分</Descriptions.Item>
                      <Descriptions.Item label="骨龄">{item.boneAge} 岁</Descriptions.Item>
                      <Descriptions.Item label="训练次数">{item.trainTimes} 次</Descriptions.Item>
                      <Descriptions.Item label="体重评估" span={2}>
                        <BMIAssessment item={item} member={currentEvaluationMember} apiClient={apiClient} bmiCache={bmiCache} setBmiCache={setBmiCache} />
                      </Descriptions.Item>
                      <Descriptions.Item label="小结" span={2}>
                        <div dangerouslySetInnerHTML={{ __html: item.briefSummary }} />
                      </Descriptions.Item>
                      <Descriptions.Item label="专家建议" span={2}>
                        <div dangerouslySetInnerHTML={{ __html: item.suggestion }} />
                      </Descriptions.Item>
                      {item.detailList && item.detailList.length > 0 && (
                        <Descriptions.Item label="测评图片" span={2}>
                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {item.detailList.map((img, imgIndex) => (
                              <Image
                                key={imgIndex}
                                src={img.phoneAddress}
                                alt={`测评图片${imgIndex + 1}`}
                                width={100}
                                height={100}
                                style={{ objectFit: 'cover' }}
                              />
                            ))}
                          </div>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Card>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  暂无测评历史
                </div>
              )}
              
              {evaluationPagination.total > 0 && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                  <Pagination
                    current={evaluationPagination.current}
                    pageSize={evaluationPagination.pageSize}
                    total={evaluationPagination.total}
                    onChange={handleEvaluationPageChange}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    size="small"
                  />
                </div>
              )}
            </Spin>
          </Tabs.TabPane>

          <Tabs.TabPane tab="新增/编辑测评" key="2">
            {isEvaluationEditMode && (
              <div style={{ marginBottom: 16, textAlign: 'right' }}>
                <Button 
                  type="default" 
                  onClick={switchToNewEvaluationMode}
                  icon={<PlusOutlined />}
                >
                  切换到新增模式
                </Button>
              </div>
            )}
            <Form form={evaluationForm} layout="vertical">
              {/* 隐藏的id字段，用于修改模式 */}
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="测评日期"
                    name="evaluationDate"
                    rules={[{ required: true, message: '请选择测评日期' }]}
                  >
                    <DatePicker 
                      style={{ width: '100%' }} 
                      format="YYYY-MM-DD" 
                      onChange={handleEvaluationDateChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="身高(cm)"
                    name="height"
                  >
                    <InputNumber 
                      min={0} 
                      precision={2}
                      style={{ width: '100%' }} 
                      parser={(value) => value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="体重(kg)"
                    name="weight"
                  >
                    <InputNumber 
                      min={0} 
                      precision={2}
                      style={{ width: '100%' }} 
                      parser={(value) => value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="心率(次/分)"
                    name="heartRate"
                  >
                    <InputNumber 
                      min={0} 
                      precision={2}
                      style={{ width: '100%' }} 
                      parser={(value) => value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="骨龄(岁)"
                    name="boneAge"
                  >
                    <InputNumber 
                      min={0} 
                      precision={2}
                      style={{ width: '100%' }} 
                      parser={(value) => value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="训练次数(次)"
                    name="trainTimes"
                    rules={[{ required: true, message: '请输入训练次数' }]}
                  >
                    <InputNumber 
                      min={0} 
                      precision={2}
                      style={{ width: '100%' }} 
                      parser={(value) => value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>小结</span>
                        <Button
                          type="link"
                          size="small"
                          icon={<EditOutlined />}
                          onClick={() => setSummaryViewMode((prev) => !prev)}
                        >
                          {summaryViewMode ? '编辑' : '查看'}
                        </Button>
                      </div>
                    }
                    name="briefSummary"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          // 移除HTML标签后验证长度
                          const text = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
                          if (text.length > 200) {
                            return Promise.reject('小结最多输入20０个字符');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                    validateTrigger="onBlur"
                  >
                    {summaryViewMode ? (
                      <div
                        style={{
                          minHeight: 80,
                          padding: '8px 12px',
                          border: '1px solid #f0f0f0',
                          borderRadius: 4,
                          background: '#fafafa',
                          whiteSpace: 'normal',
                          wordBreak: 'break-all',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: normalizeRichText(evaluationForm.getFieldValue('briefSummary') || ''),
                        }}
                      />
                    ) : (
                      <ReactQuill
                        ref={summaryRef}
                        theme="snow"
                        modules={quillModules}
                        formats={quillFormats}
                        value={evaluationForm.getFieldValue('briefSummary') || ''}
                        onChange={(content) => {
                          evaluationForm.setFieldsValue({ briefSummary: content || '' });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>专家建议</span>
                        <Button
                          type="link"
                          size="small"
                          icon={<EditOutlined />}
                          onClick={() => setSuggestionViewMode((prev) => !prev)}
                        >
                          {suggestionViewMode ? '编辑' : '查看'}
                        </Button>
                      </div>
                    }
                    name="suggestion"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          // 移除HTML标签后验证长度
                          const text = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
                          if (text.length > 200) {
                            return Promise.reject('专家建议最多输入20０个字符');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                    validateTrigger="onBlur"
                  >
                    {suggestionViewMode ? (
                      <div
                        style={{
                          minHeight: 80,
                          padding: '8px 12px',
                          border: '1px solid #f0f0f0',
                          borderRadius: 4,
                          background: '#fafafa',
                          whiteSpace: 'normal',
                          wordBreak: 'break-all',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: normalizeRichText(evaluationForm.getFieldValue('suggestion') || ''),
                        }}
                      />
                    ) : (
                      <ReactQuill
                        theme="snow"
                        modules={quillModules}
                        formats={quillFormats}
                        value={evaluationForm.getFieldValue('suggestion') || ''}
                        onChange={(content) => {
                          evaluationForm.setFieldsValue({ suggestion: content || '' });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="测评图片">
                    <Upload
                      listType="picture-card"
                      fileList={evaluationImages}
                      onChange={({ fileList }) => setEvaluationImages(fileList)}
                      onPreview={handlePreview}
                      accept="image/*"
                    >
                      <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>上传图片</div>
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ textAlign: 'right', marginTop: 16 }}>
                <Button onClick={() => setEvaluationModalVisible(false)} style={{ marginRight: 8 }}>
                  取消
                </Button>
                <Button type="primary" loading={evaluationLoading} onClick={handleSaveEvaluation}>
                  保存
                </Button>
              </div>
            </Form>
          </Tabs.TabPane>
        </Tabs>
      </Modal>



      {/* 生长发育百分位图弹窗 */}
      <Modal
        title="生长发育百分位图"
        open={percentileModalVisible}
        onCancel={closePercentileModal}
        footer={null}
        width={720}
      >
        {percentileTargetMember && (
          <div style={{ marginBottom: 16 }}>
            <span style={{ marginRight: 16 }}>姓名：{percentileTargetMember.babyName}</span>
            <span style={{ marginRight: 16 }}>性别：{percentileTargetMember.babySex === '1' ? '男' : '女'}</span>
            <span>生日：{percentileTargetMember.babyBirthday}</span>
          </div>
        )}
        {percentileError && (
          <Alert
            type="error"
            message={percentileError}
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <div style={{ minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {percentileLoading && <Spin tip="生成中..." />}
          {!percentileLoading && percentileImageSrc && (
            <Image
              src={percentileImageSrc}
              alt="生长发育百分位图"
              style={{ maxHeight: 600 }}
            />
          )}
          {!percentileLoading && !percentileImageSrc && !percentileError && (
            <span>暂无数据</span>
          )}
        </div>
      </Modal>

      {/* 结课确认弹窗 */}
      <Modal
        title="确认结课"
        open={finishConfirmVisible}
        onCancel={() => setFinishConfirmVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setFinishConfirmVisible(false)}>
            取消
          </Button>,
          <Button key="confirm" type="primary" loading={loading} onClick={handleFinishClass}>
            确认结课
          </Button>,
        ]}
      >
        <div style={{ padding: '20px' }}>
          <p>确认要结课吗？</p>
          <p><strong>扣课次数：</strong>{scheduleForm.getFieldValue('trainTimes') || 0}</p>
          <p><strong>奖励积分：</strong>{scheduleForm.getFieldValue('points') || 0}</p>
        </div>
      </Modal>
    </div>
  );
};

export default MemberList;

